import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalHeader } from 'ui-components/components/modal/modal-header';

import ModalPortal from '../../../../components/modal-portal';
import messages from './messages';
import ReturnItemsTable from './return-items-table';
import { useReturnItemsTable } from './use-return-items-table';

import style from './select-return-items-modal.module.less';

export const SelectReturnItemsModal = ({ onClose, onContinue, salesOrderId }) => {
  const { getTableProps, headerGroups, getTableBodyProps, rows, prepareRow, selectedItems } = useReturnItemsTable(salesOrderId);

  const handleContinue = useCallback(() => {
    const selectedRows = selectedItems.map((row) => {
      const { fulfillmentPlanItemId } = row.original;

      const { returnQuantity, returnReasonId } = row.values;

      return {
        fulfillmentPlanItemId,
        quantity: returnQuantity,
        returnReasonId,
      };
    });

    onContinue(selectedRows);
  }, [onContinue, selectedItems]);

  return (
    <ModalPortal onClose={onClose}>
      <Modal className={style.modal} size='large'>
        <ModalHeader closeModal={onClose}>
          <FormattedMessage {...messages.modalTitle} />
        </ModalHeader>
        <ModalBody className={style['modal-body']}>
          <ReturnItemsTable
            getTableBodyProps={getTableBodyProps}
            getTableProps={getTableProps}
            headerGroups={headerGroups}
            prepareRow={prepareRow}
            rows={rows}
          />
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose} theme='tertiary'>
            <FormattedMessage {...messages.cancelButton} />
          </Button>
          <Button onClick={handleContinue} theme='primary'>
            <FormattedMessage {...messages.continueButton} />
          </Button>
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

SelectReturnItemsModal.propTypes = {
  salesOrderId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
};
